import React, { useState } from "react";

import Button from "@cayuse/shared-react.components.button";
import ButtonGroup from "@cayuse/shared-react.components.button-group";
import Modal from "@cayuse/shared-react.components.modal";

import { useDictionary } from "hooks";
import { createNewVersion } from "store/actions/budgetBuilder";

import styles from "./styles.css";


const SaveNewVersionModal = ({ onClose, isOpen }) => {
	const dictionary = useDictionary("budgetBuilder.components.SaveNewVersionModal");

	const [ note, setNote ] = useState("");

	const onSave = () => {
		onClose();
		createNewVersion(note)
			.then(() => setNote(""));
	};


	return (
		<Modal
			closeIcon
			dimmer={{ className: styles.overrideDimmer }}
			closeOnEscape={true}
			onClose={onClose}
			open={isOpen}
			ariaLabel={dictionary.modalHeader || "Save New Version"}
		>
			<Modal.Header className="whiteOnBlue">
				<h2>{dictionary.modalHeader || "Save New Version"}</h2>
			</Modal.Header>
			<Modal.Content>
				<label>{"Note"}</label>
				<div className={"ui form"} style={{ display: "flex" }}>
					<textarea
						rows={3}
						value={note}
						onChange={({ target: { value } } ) => setNote(value)}
					/>
				</div>
			</Modal.Content>
			<Modal.Actions>
				<ButtonGroup>
					<Button secondary onClick={onClose}>
						{dictionary.cancel || "Cancel"}
					</Button>
					<Button primary onClick={onSave}>
						{dictionary.add || "Save"}
					</Button>
				</ButtonGroup>
			</Modal.Actions>
		</Modal>
	);
};

export default SaveNewVersionModal;
